import { AIInputStateControl } from '@modules/ai-conversation/components/AIInput';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAIMessageQueries } from '../../../../queries/useAIMessageQueries';
import { TextToSpeechResponse, TextToSpeechType } from '../../../hooks/types';

export const useTextToSpeechMutation = (store: AIInputStateControl) => {
  const client = useQueryClient();

  const { getTTSResponse } = useAIMessageQueries(store);

  const { mutateAsync: textToSpeech } = useMutation({
    mutationFn: ({ text, messageId }: TextToSpeechType) =>
      getTTSResponse({ text, messageId }),
    onSuccess: ({ audio, messageId }: TextToSpeechResponse) => {
      client.setQueryData<Blob>(['text-to-speech', messageId], audio);
    },
  });

  return {
    textToSpeech,
  };
};
